import { render, staticRenderFns } from "./ServerForm.vue?vue&type=template&id=1a9642a5&lang=html&"
import script from "./ServerForm.vue?vue&type=script&lang=js&"
export * from "./ServerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports